import initialState, { ICounterState } from '../modules/counter/ICounterState';
import { INCREMENT, DECREMENT, INCREMENT_VIEW } from '../modules/counter/counter.action.const';
import { increment, decrement, incrementView } from '../modules/counter/counter.reducer.logic';
import { McAction } from '../IMcAction';

export function counterReducer(state: ICounterState = initialState, action: McAction) {
    switch (action.type) {
        case INCREMENT:
            return increment(state, action);

        case DECREMENT:
            return decrement(state, action);

        case INCREMENT_VIEW:
            return incrementView(state, action);

        default:
            return state;
    }
}





// WEBPACK FOOTER //
// /home/runner/work/cdg-missioncontrol/cdg-missioncontrol/MissionControlClient2/MissionControl.WebUi2/mc-app/src/app/app-states/reducers/counter.reducer.ts